import React from 'react';

import { Box, Flex, xcss } from '@atlaskit/primitives';
import { components, type SingleValueProps } from '@atlaskit/select';
import PriorityBadge, { PRIORITIES, type Priority } from '@atlassian/eoc-priority-badge';

import { type PriorityType } from '../../../common/types';

const valueWhenFocusedStyles = xcss({
	opacity: 'opacity.disabled',
});

export const PriorityValue = <IsMulti extends boolean = false>(
	props: SingleValueProps<PriorityType, IsMulti> & { isCreatable?: boolean },
) => {
	const shouldReduceOpacity = props.selectProps.menuIsOpen && props.isCreatable;

	return (
		<components.SingleValue {...props}>
			<Box xcss={[shouldReduceOpacity && valueWhenFocusedStyles]}>
				{Object.keys(PRIORITIES).includes(props.data.value) ? (
					<Flex columnGap="space.100" alignItems="center">
						<PriorityBadge priority={props.data.value as Priority} />
						{PRIORITIES[props.data.value as Priority].label}
					</Flex>
				) : (
					props.data.label
				)}
			</Box>
		</components.SingleValue>
	);
};
